export default {
  custom: {
    name: {
      required: 'El nombre es requerido',
    },
    firstName: {
      required: 'El nombre es requerido',
    },
    lastName: {
      required: 'El apellido es requerido',
    },
    email: {
      required: 'El correo es requerido.',
      email: 'El correo no es válido.',
    },
    password: {
      required: 'La contraseña es requerida.',
    },
    role: {
      required: 'El role es requerido',
    },
    phone: {
      required: 'El telefono es requerido',
    },
    address: {
      required: 'La direccion es requerida',
    },
    sanitaryReg: {
      required: 'El registro sanitario es requerido',
    },
    expDate: {
      required: 'La fecha de expiracion es requerida',
    },
    lote: {
      required: 'El lote es requerido',
    },
    formula: {
      required: 'La presentacion es requerida',
    },
    laboratory: {
      required: 'El laboratorio es requerido',
    },
    distributor: {
      required: 'El distribuidor es requerido',
    },
    laboratories: {
      required: 'El laboratorio es requerido (al menos uno)',
    },
    total_certificate: {
      required: 'La cantidad es requerida',
      numeric: 'El valor debe ser numerico',
    },
    packageNumber: {
      required: 'El Bulto es requerido',
    },
    cif: {
      required: 'El cif es requerido',
      decimal:
        'El valor decimal es invalido, este campo acepta maximo 2 decimos',
    },
    controlNumber: {
      required: 'El # control es requerido',
    },
    invoice: {
      required: 'La factura es requerida',
    },
    orderNumber: {
      required: 'El numero de pedido es requerido',
    },
    receivedDate: {
      required: 'La fecha de recepcion es requida',
    },
    comment: {
      required: 'El comentario es requerido',
    },
    clientVisible: {
      required: 'La visibilidad de esta factura es requerida.',
    },
  },
}
